import React, { Component } from 'react';
export default class Message extends Component {
    render() {
        const buttonRestorePriorCart = this.props.restorePriorCart ?
            (React.createElement("button", { className: "btn btn-lg btn-outline-secondary m-3", onClick: this.props.restorePriorCart }, "Restore previous cart")) :
            React.createElement(React.Fragment, null);
        return (React.createElement("div", { className: "text-center", style: { margin: '5vh 0' } },
            React.createElement("h1", { className: 'pb-3' }, this.props.title),
            React.createElement("button", { className: "btn btn-lg btn-primary", onClick: this.props.findData }, "Find data"),
            buttonRestorePriorCart));
    }
}
